module.exports = __webpack_public_path__ + "img/image-not-found.7f012d13.png";